import '../../TextField.css';var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsx, jsxs } from "react/jsx-runtime";
import * as React from "react";
import { getId, css } from "@fluentui/utilities";
import { TextField as TextField$2 } from "@fluentui/react/lib/TextField";
import { ReadOnlyField } from "../ReadOnly/ReadOnlyField.js";
import "../Label/index.js";
import "../Icon/index.js";
import "../Stack.js";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { Stack } from "../Stack/Stack.js";
import { Icon } from "../Icon/Icon.js";
import { Label } from "../Label/Label.js";
const TextField = "";
const defaultClassName = "ane-TextField";
let TextField$1 = class TextField2 extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "_onRenderLabel", (props, defaultRender) => {
      const { required = false, disabled = false, labelProps = null, label = "", id } = props;
      if (!labelProps) {
        return defaultRender ? defaultRender(props) : null;
      } else {
        return /* @__PURE__ */ jsx(
          Label,
          __spreadProps(__spreadValues({}, labelProps), {
            htmlFor: `${id}-component`,
            id: `${id}-label`,
            required,
            disabled,
            children: label
          })
        );
      }
    });
  }
  render() {
    const {
      className,
      id = getId("TextField"),
      label,
      description,
      value,
      styles,
      isReadOnly,
      onRenderLabel,
      errorMessage
    } = this.props;
    const defaultDescription = isReadOnly ? "" : description;
    return isReadOnly ? /* @__PURE__ */ jsx(ReadOnlyField, { id, label, value, onRenderLabel }) : /* @__PURE__ */ jsx("div", { id, children: /* @__PURE__ */ jsx(
      TextField$2,
      __spreadProps(__spreadValues({
        title: ""
      }, this.props), {
        description: defaultDescription,
        id: `${id}-component`,
        "aria-labelledby": `${id}-component`,
        styles: mergeStyleSets(
          {
            subComponentStyles: {
              label: {
                root: {
                  fontWeight: 600
                }
              }
            },
            description: {
              wordBreak: "break-all",
              overflow: "hidden",
              whiteSpace: "normal",
              lineHeight: "14px"
            }
          },
          styles
        ),
        className: css(defaultClassName, className),
        onRenderLabel: (props, defaultRender) => this._onRenderLabel(
          __spreadProps(__spreadValues({}, this.props), {
            id
          }),
          defaultRender
        ),
        errorMessage: !!errorMessage ? /* @__PURE__ */ jsxs(Stack, { horizontal: true, verticalAlign: "start", children: [
          /* @__PURE__ */ jsx(
            Icon,
            {
              iconName: "ErrorBadge",
              ariaLabel: "Validation error",
              styles: {
                root: {
                  margin: "0",
                  padding: "0",
                  height: "16px",
                  width: "16px",
                  lineHeight: "16px",
                  paddingRight: "4px"
                }
              }
            }
          ),
          typeof errorMessage === "string" ? /* @__PURE__ */ jsx("span", { style: { whiteSpace: "normal" }, children: errorMessage }) : errorMessage
        ] }) : void 0
      })
    ) });
  }
};
export {
  TextField$1 as TextField,
  TextField$1 as default
};
//# sourceMappingURL=TextField.js.map
